import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

export const useAllMedicalTextIssuesCounts = () => {
  const queryClient = useQueryClient();

  // Fetch issue counts for all medical text examples
  const {
    data: issueCounts,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["all-medical-text-issues-counts"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("medical_text_issues")
        .select("medical_text_example_id, status")
        .eq("status", "active");

      if (error) {
        console.error("Error fetching issue counts:", error);
        throw error;
      }

      // Group by medical_text_example_id and count active issues
      const counts: Record<string, number> = {};
      data.forEach((issue) => {
        const id = issue.medical_text_example_id;
        counts[id] = (counts[id] || 0) + 1;
      });

      console.log("Fetched issue counts:", counts);
      return counts;
    },
  });

  // Real-time subscription for issue changes
  useEffect(() => {
    console.log("Setting up real-time subscription for all medical text issues");

    const channel = supabase
      .channel("all-medical-text-issues-changes")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "medical_text_issues",
        },
        (payload) => {
          console.log("Real-time change detected for issues:", payload);
          queryClient.invalidateQueries({
            queryKey: ["all-medical-text-issues-counts"],
          });
        },
      )
      .subscribe();

    return () => {
      console.log("Cleaning up real-time subscription for all issues");
      supabase.removeChannel(channel);
    };
  }, [queryClient]);

  return {
    issueCounts: issueCounts || {},
    isLoading,
    error,
    getIssueCount: (medicalTextExampleId: string) => issueCounts?.[medicalTextExampleId] || 0,
  };
};
